import { parsePhoneNumber } from 'libphonenumber-js';

const formatPhoneNumber = (
  agencyPhoneNumber: string | null | undefined,
): string | null | undefined => {
  return agencyPhoneNumber && `tel:${agencyPhoneNumber.replace(/\s/g, '')}`;
};

const formatPhoneToInternationalFormat = (phone: string | undefined, locale: string) => {
  if (!phone) {
    return '';
  }

  const [, country] = locale.split('-');
  return parsePhoneNumber(phone, country as import('libphonenumber-js').CountryCode)
    .formatInternational()
    .replace(/ /g, '');
};

const getPhoneNumber = (
  vendor: BookingVendor,
  fallbackPhoneNumber: string | null | undefined,
): string | null | undefined => {
  return (
    vendor &&
    (vendor.isSoldByClubMed && !vendor.phoneNumber ? fallbackPhoneNumber : vendor.phoneNumber)
  );
};

export { formatPhoneNumber, formatPhoneToInternationalFormat, getPhoneNumber };
